import { Injectable } from '@angular/core';
import { ApiHeaderSearchResponse } from '../api-types/header-search.api';
import { HeaderSearchQuery } from '../app-types/header-search.app';
import { transformApiHeaderSearchResponseToAppHeaderSearchResponse } from '../transformers/header-search.transform';
import { BaseRequestService } from './base-request.service';

@Injectable()
export class HeaderSearchService extends BaseRequestService {
	public search = async (query: HeaderSearchQuery) => {
		const params = this.buildSearchQueryParams(query);
		const response = await this.get<ApiHeaderSearchResponse>('header-search', params);
		return transformApiHeaderSearchResponseToAppHeaderSearchResponse(response);
	};

	private buildSearchQueryParams = (query: HeaderSearchQuery): Record<string, unknown> => {
		const params: Record<string, unknown> = {
			SearchTerm: query.searchTerm,
			Categories: query.categories,
		};

		if (query.limitPerCategory !== undefined) {
			params['LimitPerCategory'] = query.limitPerCategory;
		}
		if (query.offset !== undefined) {
			params['Offset'] = query.offset;
		}

		return params;
	};
}
